<template>
  <div class="insidePageBannar">
    <div class="pagewidth">
      <div class="titles">专业</div>
      <div class="titles-english">Majors</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InsidePageBannar',
  data: function () {
    return {
      copyrigts: 'Copyright © 2019 jxjypt.cn All Rights Reserved | 京ICP备17043231号\n' +
      '出版物许可证：新出发京零字第海180088号\n' +
      '电信业务经营许可证编号：京B2-20190114    京公网安备 11010802031480号'
    }
  },
  computed: {
    ...mapState(['city'])
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .insidePageBannar{
   height:463px;
    background:url("../../../static/images/1_01.jpg") no-repeat center center;
    .pagewidth{
      width:$pageWidth;
      margin:0 auto;
      padding-left:20px;
      color:#fff;
    }
    .titles{
      padding-top:150px;
      font-size:38px;
      margin-bottom:20px;
    }
    .titles-english{
      font-size:24px;
      text-transform :uppercase;
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/components/InsidePageBannar.vue